"use client";
import { Controller, useFormContext } from "react-hook-form";
import { Box } from "@mui/material";
import { StyledTextField } from "./StyleInputs";
import { parseNumber } from "utils/formUtils";

const NumberField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  return (
    <Box sx={{ mb: 3 }}>
      <Controller
        name={field.id}
        control={control}
        defaultValue=""
        rules={{
          required: field.required ? `${field.label} is required` : false,
          validate: (value) => {
            if (
              field.validation?.min !== undefined &&
              Number(value) < parseNumber(field.validation.min)
            ) {
              return `Value must be at least ${field.validation.min}`;
            }
            if (
              field.validation?.max !== undefined &&
              Number(value) > parseNumber(field.validation.max)
            ) {
              return `Value must be at most ${field.validation.max}`;
            }
            return true;
          },
        }}
        render={({ field: { onChange, value, ref } }) => (
          <StyledTextField
            fullWidth
            placeholder={field.placeholder}
            type="number"
            value={value}
            onChange={onChange}
            inputRef={ref}
            error={!!errorMessage}
            helperText={errorMessage}
            variant="outlined"
            required={field.required}
            label={field.label}
          />
        )}
      />
    </Box>
  );
};

export default NumberField;
